import styled from 'styled-components';

export const DurationPicker = styled.div`
  display: flex;
  text-align: center;
`;

export const Inner = styled.div`
  display: flex;
  margin: auto;
`;

export const Field = styled.div`
  min-width: 5rem;

  + ${() => Field} {
    margin-left: ${p => (p.device === 'desktop' ? 1 : 0.5)}rem;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  margin-top: 8px;
  opacity: 0.7;
`;
